import UserCouponListContainer from './UserCouponListContainer';
export default UserCouponListContainer;
